// `massaging` is not a typo, that's what the cookie is currently called
export const FLASH_MESSAGES_COOKIE = 'js_flash_massaging'
